import parseDialogue from "../../util/parseDialogue";

export const DisarrayP5 = parseDialogue(`
disarray:p5:100-800

#100 Hello there, S.M.A.R.T amateur.
>200 What do you want?

#200 What's the matter? No time to chat with an old S.M.A.R.T buddy?
>300 S.M.A.R.T kicked you out.

#300 Clearly their loss. So I guess by now you know the whole nightfall story, huh?
>400 Why are you trying to crash the net?

#400 Simple. The nightfall software I set up is going to take every single node off-line. That means I will control who gets access to the net and who doesn't.
>500 So?

#500 People will be begging me to get back on-line. And I'll let them. Just as long as they're willing to pay for the privilege. I'll make billions. What can I say - it's a brilliant plan.
>600 That will never happen.

#600 Actually, it will. You don't have the codes to access my private node, and even if you did, you'd never beat my security. You're just a pathetic newbie. So why don't you stop wasting your time fighting me and go save up your credits to pay me off later?
>700 You're going down, Disarray.

#700 Suit yourself. It'll be fun to show you just how inferior you are. L8r, loser.
>800 We'll see.
`);
